import { render, staticRenderFns } from "./SG.vue?vue&type=template&id=31ee045e"
import script from "./SG.vue?vue&type=script&lang=ts"
export * from "./SG.vue?vue&type=script&lang=ts"
import style0 from "./SG.vue?vue&type=style&index=0&id=31ee045e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports